import React, { useState } from "react";
import { Button } from "antd";
import {
  EnvironmentOutlined,
  PlusOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import LocationFilters from "./LocationFilters";

interface LocationHeaderProps {
  onAddLocation: () => void;
  onApplyFilters: (filters: Record<string, any>) => void;
  onClearFilters: () => void;
  canAddLocations: boolean; // Permission check
}

const LocationHeader: React.FC<LocationHeaderProps> = ({
  onAddLocation,
  onApplyFilters,
  onClearFilters,
  canAddLocations,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  // Define filter fields for all location table columns
  const filterFields = [
    { key: "name", label: "Location Name", type: "text" as const },
    { key: "address", label: "Address", type: "text" as const },
    { key: "code", label: "Location Code", type: "text" as const },
  ];

  return (
    <div className="mb-6">
      {/* Header Section */}
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-4 space-y-4 lg:space-y-0">
        <div className="flex items-center space-x-2">
          <EnvironmentOutlined className="text-xl text-primary" />
          <h1 className="text-lg lg:text-xl font-bold">Location Management</h1>
        </div>

        <div className="flex space-x-3">
          {/* Only show Add Location button if user has permission */}
          {canAddLocations && (
            <Button
              type="default"
              onClick={onAddLocation}
              icon={<PlusOutlined />}
              className="border border-primary text-primary"
            >
              Add New Location
            </Button>
          )}
          <Button
            icon={<FilterOutlined />}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters
          </Button>
        </div>
      </div>

      {/* Filters Section */}
      {showFilters && (
        <LocationFilters
          fields={filterFields}
          onApplyFilters={onApplyFilters}
          onClearFilters={onClearFilters}
        />
      )}
    </div>
  );
};

export default LocationHeader;
